import { useMaterials, useSelectedValueByVariableKey } from '@k3/core'
import { isEFormUnichromeType, Keys, MaterialNames } from '../utility/utils'
import { useDimensions } from './useDimensions'
import { useLoader } from '@react-three/fiber'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { sRGBEncoding, Vector2 } from 'three'
import { useEffect, useMemo, useState } from 'react'
import { SupportedMaterial } from '@k3/core/src/lib/types/material.interface'
import { loadMaterial } from '../utility/materialLoader'

const alpha = 'textures/SolarCells_alpha.png'
export const SolarPanelGeometry = (props: any) => {
  const [material, setMaterial] = useState<SupportedMaterial>()
  const [fakeMaterial, setFakeMaterial] = useState<SupportedMaterial>()
  const materialList = useMaterials()
  const materials = useMemo(
    () => new Map(materialList.map((m) => [m.name, m])),
    [materialList]
  )
  const productValue = useSelectedValueByVariableKey(Keys.EFormType.Variable)

  const busbarAbdeckung = useSelectedValueByVariableKey(
    Keys.BusbarAbdeckung.Variable
  )
  const abgedeckt =
    busbarAbdeckung?.key?.toString() === Keys.BusbarAbdeckung.Value.Selected

  const addFake = !abgedeckt && isEFormUnichromeType(productValue)
  const alphaMap = useLoader(TextureLoader, alpha, undefined, (p) =>
    console.log(p)
  )

  useEffect(() => {
    const name = abgedeckt
      ? MaterialNames.Zellen_abgedeckt
      : MaterialNames.Zellen
    if (materials.has(name)) {
      loadMaterial(materials.get(name)!, (mat) => {
        if (mat.map) {
          mat.map.encoding = sRGBEncoding
        }
        mat.normalScale = new Vector2(0.1, 0.1)
        setMaterial(mat)
        if (addFake) {
          const fake = mat.clone()
          fake.transparent = true
          fake.opacity = 0.85
          fake.alphaMap = alphaMap
          setFakeMaterial(fake)
        } else {
          setFakeMaterial(undefined)
        }
      })
    } else {
      setMaterial(undefined)
    }
  }, [materials, abgedeckt, addFake, alphaMap])

  const { panelDimensions, solarCellThickness, length, width } = useDimensions()
  const rotation: [number, number, number] = [
    0,
    0,
    length < width ? Math.PI / 2 : 0,
  ]

  return material ? (
    <group position={props.position} rotation={rotation}>
      <mesh material={material}>
        <boxGeometry
          args={[panelDimensions, panelDimensions, solarCellThickness]}
        />
      </mesh>

      {fakeMaterial && addFake && (
        <mesh
          position={[0, 0, -0.0002]}
          castShadow={false}
          receiveShadow={false}
          renderOrder={1}
          material={fakeMaterial}
        >
          <boxGeometry
            args={[panelDimensions, panelDimensions, solarCellThickness]}
          />
        </mesh>
      )}
    </group>
  ) : null
}
